var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTirAuButHandBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #4970b5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,70.8c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM57.3,57.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55 61.1 57.3 62.4 57.3 65.4 55.3 66.7 53 65.4 52.9 62.5 55 61.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,66.8l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM53.1,65.3l2.2,1.2,1.9-1.2v-2.9l-2.2-1.3-2,1.4v2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "57.3 58.7 56 59 55 61.1 57.3 62.4 59.6 61.1 58.6 59 57.3 58.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,62.5l-2.4-1.4,1-2.2,1.3-.3,1.4.3,1,2.2-2.4,1.4ZM55.1,61l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.8 62.6 51.6 61.8 52.3 59.6 54.7 58.2 56.1 58.9 56 59.1 54.7 58.4 52.4 59.7 51.8 61.7 52.9 62.5 52.8 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.6 66.2 50.6 64 51.6 61.7 51.8 61.8 50.8 64 51.7 65.9 52.9 65.3 53 65.5 51.6 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.7 69.8 52.4 68.6 51.6 66.1 51.8 66.1 52.5 68.5 54.7 69.6 56 68.8 56.1 69 54.7 69.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,70.8c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM57.3,57.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.6 61.1 57.3 62.4 57.3 65.4 59.4 66.7 61.7 65.4 61.8 62.5 59.6 61.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,66.8l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c0,0-2.5,1.3-2.5,1.3ZM57.4,65.3l1.9,1.2,2.2-1.2v-2.7c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "61.8 62.6 61.7 62.5 62.8 61.7 62.2 59.7 59.9 58.4 58.7 59.1 58.6 58.9 59.9 58.2 62.4 59.6 63 61.8 61.8 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "63 66.2 61.6 65.5 61.7 65.3 62.9 65.9 63.8 64 62.8 61.8 63 61.7 64 64 63 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.9 69.8 58.6 69 58.7 68.8 59.9 69.6 62.1 68.5 62.8 66.1 63 66.1 62.2 68.6 59.9 69.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 58.8,
    y: 70,
    width: 1.2,
    height: 0.2,
    transform: "translate(-30.8 52.8) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "56 68.9 57.3 69.3 58.6 68.9 59.4 66.7 57.3 65.4 55.3 66.7 56 68.9 57.3 69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,69.4l-1.4-.4-.7-2.3,2.1-1.4,2.3,1.4-.9,2.3-1.4.4ZM56.1,68.8l1.2.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,57.6c1.7.3,3.2,1.9,3.2,1.9v.2c.1,0-2.3-1.3-2.3-1.3h0s-.9-.7-.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.5,59.9l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM59.9,58.2l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.6,57.6c-1.7.3-3.2,2-3.2,2h0c0,0,2.3-1.2,2.3-1.2h0s.9-.7.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3,59.8v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM55.2,57.8c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,59.1l-1.3-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,59.3l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,1.9-.5,3.4,0h0s1,.8,1,.8l-1.4.9ZM57.2,58.6l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.6,70.5c-1.7-.3-3.2-1.9-3.2-1.9l2.3,1.1h0s.9.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,70.6h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM53,69c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,70.5c1.7-.3,3.2-1.9,3.2-1.9l-2.3,1.1h0s-.9.7-.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,70.6l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM59.9,69.8l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,68.9l1.3.4,1.3-.4,1.3.8-.9.7s-1.9.5-3.4,0l-.9-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,70.8c-.5,0-1.1,0-1.6-.2h0s-1-.8-1-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.2-1.8.2ZM55.6,70.4c1.4.4,3.1,0,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.8,50.5l-.2-27.2c0-.1,0-.2.1-.3,0,0,.2-.1.3-.1h49.5c.2,0,.4.2.4.4l.2,27.2h-.9s-.2-26.8-.2-26.8h-48.7l.2,26.8h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,51.3l-4-5.4c0,0,0-.2,0-.3l4-22.3h.8c0,.1-3.9,22.3-3.9,22.3l3.9,5.2-.7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 54.3,
    y: 45.2,
    width: 41.4,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,45.7l-3.3-22.3c0-.1,0-.2,0-.3,0,0,.2-.1.3-.1h4.1c.2,0,.4.2.4.4l2.5,22.3h-.9c0,0-2.4-21.8-2.4-21.8h-3.2l3.2,21.8h-.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 55.9,
    y: 23.1,
    width: 0.9,
    height: 22.7,
    transform: "translate(-5.3 10.7) rotate(-10.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,45.7h-.8c0-.1,3.2-21.9,3.2-21.9h-3.2l-2.4,21.9h-.9c0,0,2.5-22.4,2.5-22.4,0-.2.2-.4.4-.4h4.1c.1,0,.2,0,.3.1,0,0,.1.2,0,.3l-3.3,22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 82.2,
    y: 34,
    width: 22.7,
    height: 0.9,
    transform: "translate(42.8 120.3) rotate(-79.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 67.1,
    y: 23.3,
    width: 0.9,
    height: 22.4,
    transform: "translate(-2.4 5.1) rotate(-4.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 71.1,
    y: 34,
    width: 22.4,
    height: 0.9,
    transform: "translate(42.4 114.3) rotate(-86.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 70.7,
    y: 23.3,
    width: 0.9,
    height: 22.3,
    transform: "translate(-1.3 2.9) rotate(-2.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 67.5,
    y: 34,
    width: 22.3,
    height: 0.9,
    transform: "translate(41.4 111.7) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.9,46.1h0c-.2,0-.4-.2-.4-.4h0s0-22.3,0-22.3c0-.2.2-.4.4-.4h0c.2,0,.4.2.4.4h0s0,22.3,0,22.3c0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,34.6l-.9-5.1h-47.1v-.9h47.5c.2,0,.4.1.4.4l1,5.5-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,40.2l-1.9-5.3h-45.2v-.9h45.5c.2,0,.3.1.4.3l2,5.5-.8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 53.3,
    y: 39.6,
    width: 43.4,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.4 51.3 49.8 50.7 53.8 45.5 49.7 23.4 50.5 23.2 54.8 45.7 50.4 51.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 50.9,
    y: 23.3,
    width: 0.9,
    height: 24.8,
    transform: "translate(-3.2 5.1) rotate(-5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,51.3l-4.2-5.4c0,0-.1-.2,0-.3l4.2-22.3c0-.2.3-.4.5-.3.2,0,.4.2.4.5l-2.4,24.5,2.3,2.9-.7.5ZM96.1,45.5l1,1.3,1.4-14.1-2.4,12.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 48.6,
    y: 42.4,
    width: 6.3,
    height: 0.9,
    transform: "translate(-10.3 68.6) rotate(-62.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 48.1,
    y: 36.8,
    width: 6,
    height: 0.9,
    transform: "translate(-1.5 72.2) rotate(-69.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 47.8,
    y: 31.2,
    width: 5.6,
    height: 0.9,
    transform: "translate(10.2 75.5) rotate(-79.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 97.7,
    y: 40,
    width: 0.9,
    height: 6.1,
    transform: "translate(-8.5 53.6) rotate(-29.3)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,76.3c0,.4-3.1.8-6.8.8s-6.8-.3-6.8-.8,3.1-.8,6.8-.8,6.8.3,6.8.8Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,67.1c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM75.1,53.8c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.8 57.4 75.1 58.7 75.1 61.7 73.1 63 70.8 61.7 70.7 58.8 72.8 57.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,63.1l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM70.9,61.6l2.2,1.2,1.9-1.2v-2.9l-2.2-1.3-2,1.4v2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "75.1 55 73.8 55.3 72.8 57.4 75.1 58.7 77.4 57.4 76.4 55.3 75.1 55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,58.8l-2.4-1.4,1-2.2,1.3-.3,1.4.3,1,2.2-2.4,1.4ZM73,57.3l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70.6 58.9 69.4 58.1 70.1 55.9 72.5 54.5 73.9 55.2 73.8 55.4 72.5 54.7 70.2 56 69.6 58 70.7 58.8 70.6 58.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "69.5 62.5 68.4 60.3 69.4 58 69.6 58.1 68.6 60.3 69.5 62.3 70.7 61.6 70.8 61.8 69.5 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.5 66.1 70.2 64.9 69.4 62.4 69.6 62.4 70.4 64.8 72.5 65.9 73.8 65.2 73.9 65.3 72.5 66.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,67.1c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM75.1,53.8c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.5 57.4 75.1 58.7 75.1 61.7 77.2 63 79.5 61.7 79.6 58.8 77.5 57.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,63.1l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c0,0-2.5,1.3-2.5,1.3ZM75.2,61.6l1.9,1.2,2.2-1.2v-2.7c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.6 58.9 79.5 58.8 80.6 58 80 56 77.7 54.7 76.5 55.4 76.4 55.2 77.7 54.5 80.2 55.9 80.9 58.1 79.6 58.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.8 62.5 79.4 61.8 79.5 61.6 80.7 62.3 81.6 60.3 80.7 58.1 80.8 58 81.8 60.3 80.8 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.7 66.1 76.4 65.3 76.5 65.2 77.7 65.9 79.9 64.8 80.7 62.4 80.8 62.4 80.1 64.9 77.7 66.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 76.7,
    y: 66.3,
    width: 1.2,
    height: 0.2,
    transform: "translate(-24.6 63.1) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "73.8 65.2 75.1 65.6 76.4 65.2 77.3 63 75.1 61.7 73.1 63 73.8 65.2 75.1 65.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,65.7l-1.4-.4-.7-2.3,2.1-1.4,2.3,1.4-.9,2.3-1.4.4ZM73.9,65.1l1.2.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,53.9c1.7.3,3.2,1.9,3.2,1.9v.2c.1,0-2.3-1.3-2.3-1.3h0s-.9-.7-.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.4,56.2l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM77.7,54.6l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,53.9c-1.7.3-3.2,2-3.2,2h0c0,0,2.3-1.2,2.3-1.2h0s.9-.7.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.1,56.1v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM73.1,54.1c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.4,55.5l-1.3-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,55.6l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,1.9-.5,3.4,0h0s1,.8,1,.8l-1.4.9ZM75,55l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,66.8c-1.7-.3-3.2-1.9-3.2-1.9l2.3,1.1h0s.9.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,66.9h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM70.8,65.3c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,66.8c1.7-.3,3.2-1.9,3.2-1.9l-2.3,1.1h0s-.9.7-.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.4,66.9l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM77.7,66.1l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,65.2l1.3.4,1.3-.4,1.3.8-.9.7s-1.9.5-3.4,0l-.9-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,67.1c-.5,0-1.1,0-1.6-.2h0s-1-.8-1-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.2-1.8.2ZM73.5,66.7c1.4.4,3.1,0,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.5,70.8c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM92.5,57.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.2 61.1 92.5 62.4 92.5 65.4 90.5 66.7 88.2 65.4 88.1 62.5 90.2 61.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.5,66.8l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM88.3,65.3l2.2,1.2,1.9-1.2v-2.9l-2.2-1.3-2,1.4v2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "92.5 58.7 91.2 59 90.2 61.1 92.5 62.4 94.8 61.1 93.8 59 92.5 58.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,62.5l-2.4-1.4,1-2.2,1.3-.3,1.4.3,1,2.2-2.4,1.4ZM90.4,61l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "88 62.6 86.8 61.8 87.5 59.6 89.9 58.2 91.3 58.9 91.2 59.1 89.9 58.4 87.6 59.7 87 61.7 88.1 62.5 88 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "86.9 66.2 85.8 64 86.8 61.7 87 61.8 86 64 86.9 65.9 88.1 65.3 88.2 65.5 86.9 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "89.9 69.8 87.6 68.6 86.8 66.1 87 66.1 87.7 68.5 89.9 69.6 91.2 68.8 91.3 69 89.9 69.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.5,70.8c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM92.5,57.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5,6.5-2.9,6.5-6.5-2.9-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "94.9 61.1 92.5 62.4 92.5 65.4 94.6 66.7 96.9 65.4 97 62.5 94.9 61.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.6,66.8l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c0,0-2.5,1.3-2.5,1.3ZM92.6,65.3l1.9,1.2,2.2-1.2v-2.7c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97 62.6 96.9 62.5 98 61.7 97.4 59.7 95.1 58.4 93.9 59.1 93.8 58.9 95.1 58.2 97.6 59.6 98.3 61.8 97 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.2 66.2 96.8 65.5 96.9 65.3 98.1 65.9 99 64 98.1 61.8 98.2 61.7 99.2 64 98.2 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "95.1 69.8 93.8 69 93.9 68.8 95.1 69.6 97.3 68.5 98.1 66.1 98.2 66.1 97.5 68.6 95.1 69.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 94,
    y: 70,
    width: 1.2,
    height: 0.2,
    transform: "translate(-23 74.9) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "91.2 68.9 92.5 69.3 93.8 68.9 94.7 66.7 92.5 65.4 90.5 66.7 91.2 68.9 92.5 69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,69.4l-1.4-.4-.7-2.3,2.1-1.4,2.3,1.4-.9,2.3-1.4.4ZM91.3,68.8l1.2.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,57.6c1.7.3,3.2,1.9,3.2,1.9v.2c.1,0-2.3-1.3-2.3-1.3h0s-.9-.7-.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.8,59.9l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM95.1,58.2l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,57.6c-1.7.3-3.2,2-3.2,2h0c0,0,2.3-1.2,2.3-1.2h0s.9-.7.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,59.8v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM90.5,57.8c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.8,59.1l-1.3-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,59.3l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,1.9-.5,3.4,0h0s1,.8,1,.8l-1.4.9ZM92.4,58.6l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,70.5c-1.7-.3-3.2-1.9-3.2-1.9l2.3,1.1h0s.9.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2,70.6h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM88.2,69c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,70.5c1.7-.3,3.2-1.9,3.2-1.9l-2.3,1.1h0s-.9.7-.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.8,70.6l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM95.1,69.8l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2,68.9l1.3.4,1.3-.4,1.3.8-.9.7s-1.9.5-3.4,0l-.9-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,70.8c-.5,0-1.1,0-1.6-.2h0s-1-.8-1-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.2-1.8.2ZM90.9,70.4c1.4.4,3.1,0,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirAuButHandBleu);
export default __webpack_public_path__ + "static/media/tir_au_but_hand_bleu.7c4c3b5c7f97a4ae6cce07eb40387c34.svg";
export { ForwardRef as ReactComponent };